import { IDmMucHocPhiTheoMonCopyRequest } from "../../../model/request/category/dmMucHocPhiTheoMonCopyRequest";
import { IDmMucHocPhiTheoMonViewModelRequest } from "../../../model/request/category/dmMucHocPhiTheoMonViewModelRequest";
import { IDmMucHocPhiTheoMon } from "../../../model/respone/category/IDmMucHocPhiTheoMon";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmMucHocPhiTheoMonActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  LOAD_START: {} as IDmMucHocPhiTheoMonViewModelRequest,
  LOAD_SUCCESS: {} as IDmMucHocPhiTheoMon[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDmMucHocPhiTheoMon[],
  SAVE_SUCCESS: {} as IDmMucHocPhiTheoMon[],
  SAVE_ERROR: "",

  CHANGE_REQUEST: {} as IDmMucHocPhiTheoMonViewModelRequest,

  LOCK_START: {} as IDmMucHocPhiTheoMonViewModelRequest,
  LOCK_SUCCESS: {} as IDmMucHocPhiTheoMon[],
  LOCK_ERRR: "",

  UNLOCK_START: {} as IDmMucHocPhiTheoMonViewModelRequest,
  UNLOCK_SUCCESS: {} as IDmMucHocPhiTheoMon[],
  UNLOCK_ERRR: "",

  SHOWHIDE_COPY_MODAL: {} as boolean,
  COPY_START: {} as IDmMucHocPhiTheoMonCopyRequest,
  COPY_SUCCESS: {} as IDmMucHocPhiTheoMon[],
  COPY_ERROR: "",
  COPY_CHANGE_REQUEST: {} as any,

  CHANGE_MODE_EDIT: {} as number,

  CHANGE_EXPANDED_KEYS: {} as string[],
};
export const eDmMucHocPhiTheoMonActionIds = generateActionTypeIds(
  eDmMucHocPhiTheoMonActionsObj,
  "MUC_HOC_PHI_THEO_MON",
);
export type IDmMucHocPhiTheoMonActionTypes = IGenericActionType<
  typeof eDmMucHocPhiTheoMonActionsObj,
  "MUC_HOC_PHI_THEO_MON"
>;
